import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includedItems } from '../data/content';
import { carouselTwo } from '../data/carousels';
import { ProjectCarousel } from './ProjectCarousel';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section className="px-6 py-12" style={{
    marginTop: "-50px",
    marginBottom: "-50px"
  }} data-id="element-191" data-mp="pv2iq70gbj83">
      <SectionHeading eyebrow="Tutto incluso" data-id="element-192" data-mp="b6g64d27l5kk">
        Cosa <span className="accent-underline" data-id="element-193" data-mp="b4vaek45rgl4">trovi</span> dentro?
      </SectionHeading>

      <div className="mt-6 rounded-2xl border border-cream-300 bg-cream-50 px-6 py-5 text-center" data-id="element-194" data-mp="fy6hmmcvtzdk">
        <p className="font-display text-[22px] font-semibold tracking-[-0.01em] text-gold-500" data-id="element-195" data-mp="26t5hthb03sk">
          Oltre 365 progetti e attività
        </p>
        <p className="mt-1.5 text-[15px] leading-[1.6] text-ink-500" data-id="element-196" data-mp="72gplugxi6r7">
          suddivisi in progetti pratici, esperimenti, costruzioni creative e attività da stampare per
          creare, imparare e giocare a casa.
        </p>
      </div>

      <ul className="mt-8 space-y-6" data-id="element-197" data-mp="3ct4k2ebcultb">
        {includedItems.map(item => <li key={item.title} className="flex gap-3.5" data-id="element-198" data-mp="37utc694meldq">
            <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-500/10" aria-hidden="true" data-id="element-199" data-mp="37ub6klw2iut5">
              <CheckIcon className="h-3 w-3 text-forest-600" strokeWidth={3} data-id="element-200" data-mp="3ht0qslbfsrck" />
            </span>
            <p className="text-[16.5px] leading-[1.65] text-ink-500" data-id="element-201" data-mp="2u3fuz1u6pzlv">
              <span className="font-semibold text-ink-900" data-id="element-202" data-mp="2u3o9ey5yhcz6">{item.title}</span> {item.detail}
            </p>
          </li>)}
      </ul>

      <div className="-mx-6 mt-10" data-id="element-203" data-mp="32vq7ipsjyh6a">
        <ProjectCarousel images={carouselTwo} direction="right" durationSeconds={38} data-id="element-204" data-mp="32wrthpb3wo2s" />
      </div>
    </section>;
}